(() => {
  const qs=(s,r=document)=>r.querySelector(s);
  const openDrawer=()=>qs('[data-vv-cart-drawer]')?.setAttribute('open','');
  const closeDrawer=()=>qs('[data-vv-cart-drawer]')?.removeAttribute('open');

  async function refreshDrawer(){
    const url=new URL(location.href);
    url.searchParams.set('section_id','vv-cart-drawer-section');
    const html=await fetch(url.toString(),{headers:{'X-Requested-With':'XMLHttpRequest'}}).then(r=>r.text());
    const doc=new DOMParser().parseFromString(html,'text/html');
    const fresh=doc.querySelector('#shopify-section-vv-cart-drawer-section');
    const old=document.querySelector('#shopify-section-vv-cart-drawer-section');
    if(fresh && old) old.replaceWith(fresh);
  }

  async function refreshCartCount(){
    const cart=await fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(r=>r.json());
    const cartLink=qs('[data-vv-cart-open]');
    if(!cartLink) return;
    let badge=cartLink.querySelector('.vv-cart-count');
    if(cart.item_count>0){
      if(!badge){badge=document.createElement('span');badge.className='vv-cart-count';cartLink.appendChild(badge);}
      badge.textContent=String(cart.item_count);
    }else if(badge){badge.remove();}
    cartLink.setAttribute('aria-label',cart.item_count?`Cart, ${cart.item_count} item${cart.item_count===1?'':'s'}`:'Cart');
  }

  document.addEventListener('click',e=>{
    if(e.target.closest('[data-vv-cart-close]')){e.preventDefault();closeDrawer();return;}
    if(e.target.closest('[data-vv-cart-open]')){e.preventDefault();openDrawer();}
  });

  document.addEventListener('keydown',e=>{if(e.key==='Escape')closeDrawer();});

  document.addEventListener('submit',async e=>{
    const form=e.target.closest('[data-vv-product-form]');
    if(!form || !window.fetch) return;
    e.preventDefault();
    const btn=form.querySelector('[type=submit]');
    const original=btn?.textContent;
    btn?.setAttribute('disabled','');
    btn?.setAttribute('aria-busy','true');
    if(btn) btn.textContent='Adding…';
    try{
      const res=await fetch(window.vvRoutes.cartAdd,{method:'POST',body:new FormData(form),headers:{'Accept':'application/json'}});
      if(!res.ok) throw new Error('Cart add failed');
      await Promise.all([refreshDrawer(),refreshCartCount()]);
      openDrawer();
    }catch(err){
      form.submit();
    }finally{
      btn?.removeAttribute('disabled');
      btn?.removeAttribute('aria-busy');
      if(btn && original) btn.textContent=original;
    }
  });
})();
